import Vue from "vue";
import Vuex from "vuex";
import createLogger from "vuex/dist/logger";
import createPersistedState from "vuex-persistedstate";
import * as Cookies from "tiny-cookie";

import router from "../router";

import { EventBus } from "../EventBus";
import UserService from "../services/user";

import VenueService from "../services/venue";
import ExhibtiCategoryService from "../services/category";

import OrganizationService from "../services/organization";
import ExhibitorService from "../services/exhibitor";

import { get, post, request } from "../http/http";
import i18n from "../i18n";

Vue.use(Vuex);

// 文章分类（栏目）的展示顺序，接口未返回排序字段，这里按中英文名称匹配
// 未匹配到的分类保持接口原有相对顺序，排在最后
const ARTICLE_CATEGORY_ORDER = [
  ["行业动态", "Industry News"],
  ["展会动态", "Exhibition News"],
  ["骑行之家", "Cyclist's Home"],
  ["两轮故事", "Industry History"],
  ["政策法规", "Industry Policy"],
  ["精彩视频", "Video"]
];

const articleCategoryIndex = articleCategory => {
  const name = ((articleCategory && articleCategory.name) || "")
    .trim()
    .toLowerCase();
  const index = ARTICLE_CATEGORY_ORDER.findIndex(names =>
    names.some(item => item.toLowerCase() === name)
  );
  return index === -1 ? ARTICLE_CATEGORY_ORDER.length : index;
};

const sortArticleCategories = (articleCategories = []) =>
  articleCategories
    .slice()
    .sort((a, b) => articleCategoryIndex(a) - articleCategoryIndex(b));

console.log(sessionStorage.getItem("user"));

export default new Vuex.Store({
  state: {
    exhibitor: {},
    authentication: {},
    account: {},
    user: sessionStorage.getItem("user")
      ? JSON.parse(sessionStorage.getItem("user"))
      : {},
    collected: [],
    liked: [],
    venues: [],
    exhibitCategories: [],
    articleCategories: []
  },
  getters: {
    hasAuthentication: state => () => {
      return state.authentication && state.authentication.token;
    },
    hasCollected: state => (type, id) => {
      let key = "";

      switch (type) {
        case "EXHIBITOR":
          key = "exhibitor";
          break;
        case "EXHIBIT":
          key = "exhibit";
          break;
        case "LIVESTREAM":
          key = "livestream";
          break;
        case "ARTICLE":
          key = "article";
          break;
        default:
          break;
      }

      return (
        state.collected.findIndex(
          c => c.objectType == type && c.objectId == id
        ) != -1
      );
    },
    getCollected: state => (type, id) => {
      let key = "";

      switch (type) {
        case "EXHIBITOR":
          key = "exhibitor";
          break;
        case "EXHIBIT":
          key = "exhibit";
          break;
        case "LIVESTREAM":
          key = "livestream";
          break;
        case "ARTICLE":
          key = "article";
          break;
        default:
          break;
      }

      return state.collected.find(
        c => c.objectType == type && c.objectId === id
      );
    },
    hasLiked: state => (type, id) => {
      let key = "";

      switch (type) {
        case "EXHIBITOR":
          key = "exhibitor";
          break;
        case "EXHIBIT":
          key = "exhibit";
          break;
        case "LIVESTREAM":
          key = "livestream";
          break;
        case "ARTICLE":
          key = "article";
          break;
        default:
          break;
      }

      return (
        state.liked.findIndex(l => l.objectType == type && l.objectId === id) !=
        -1
      );
    },
    getLiked: state => (type, id) => {
      let key = "";

      switch (type) {
        case "EXHIBITOR":
          key = "exhibitor";
          break;
        case "EXHIBIT":
          key = "exhibit";
          break;
        case "LIVESTREAM":
          key = "livestream";
          break;
        case "ARTICLE":
          key = "article";
          break;
        default:
          break;
      }

      return state.liked.find(l => l.objectType == type && l.objectId === id);
    }
  },
  mutations: {
    setAuthentication: (state, payload) => {
      console.log("---------=============*****************");
      debugger;
      state.authentication = payload;
      localStorage.setItem("token", payload.token);
      sessionStorage.setItem(
        "user",
        payload.user ? JSON.stringify(payload.user) : null
      );

      if (payload.user && payload.user.id) {
        state.user = payload.user;
      }
    },

    SET_USER: (state, payload) => {
      state.user = payload;
      //
      // if (payload.organization) {
      //   state.organization = payload.organization;
      // }
    },
    SET_COLLECTED: (state, collected) => {
      state.collected = collected;
      EventBus.$emit("setCollected");
    },
    SET_LIKED: (state, liked) => {
      state.liked = liked;
      EventBus.$emit("setLiked");
    },
    setVenues: (state, venues) => {
      state.venues = venues;
    },
    setExhibitCategories: (state, exhibitCategories) => {
      state.exhibitCategories = exhibitCategories;
    },
    setArticleCategories: (state, articleCategories) => {
      state.articleCategories = articleCategories;
    },
    setOrganization(state, payload) {
      state.organization = payload;

      if (payload.exhibitors && payload.exhibitors.length > 0) {
        state.exhibitor = payload.exhibitors[0];
      }
    },
    setVistor(state, payload) {
      state.vistor = payload;
      if (payload.organization && payload.organization.id) {
        state.organization = payload.organization;
      }
    },
    setExhibitor(state, payload) {
      state.exhibitor = payload;
      if (payload.organization && payload.organization.id) {
        state.organization = payload.organization;
      }
    }
  },

  actions: {
    // user login
    async addAuthentication({ state, dispatch, commit }, authenticationParam) {
      let authentication = null;
      if (authenticationParam.type === "Exhibitor") {
        authentication = await post(
          "/web/login/byExhibitor",
          authenticationParam.params
        );
        commit("setExhibitor", authentication.exhibitor);
      } else {
        authentication = await post(
          "/web/login/byAudience",
          authenticationParam
        );
      }

      if (!authentication.token) {
        return authentication;
      }

      commit("setAuthentication", authentication);

      console.log(authentication);

      // 设置user
      commit("SET_USER", authentication.user);

      await dispatch("getAuthenticationUser");

      if (authentication.user.organizationId) {
        // await dispatch("getUserOrganization");
        // await dispatch("getOrganizationExhibitor");
      }

      dispatch("getCollecteds");
      dispatch("getLikeds");

      Cookies.set(
        "authentication",
        JSON.stringify({
          user: authentication.user,
          token: authentication.token
        }),
        {
          expires: authenticationParam.rememberMe ? 7 : 1,
          domain: ["localhost", "127.0.0.1"].includes(document.domain)
            ? document.domain
            : ".e-chinacycle.com"
        }
      );
      return authentication;
    },
    // 前端 登出
    deleteAuthentication({ commit }) {
      commit("setAuthentication", {});
      commit("SET_USER", {});
      commit("SET_COLLECTED", []);
      commit("SET_LIKED", []);
      commit("setExhibitor", {});
      commit("setOrganization", {});
      const lang = localStorage.getItem("language");
      localStorage.clear();
      localStorage.setItem("language", lang);

      Cookies.set("authentication", "", {
        expires: 1,
        domain: ["localhost", "127.0.0.1"].includes(document.domain)
          ? document.domain
          : ".e-chinacycle.com"
      });
    },
    async getUser({ state, commit }) {
      const result = await UserService.getEntity({
        id: state.user.id
      });

      commit("SET_USER", result);
    },
    async getCollecteds({ state, commit }) {
      // const result = await CollectedRecordService.getEntities({
      //   "user.id": state.user.id
      // })

      const result = await get("/my/operationRecordPage", {
        type: "COLLECTED",
        userId: state.user.id
      });

      commit("SET_COLLECTED", result.content);
    },
    async addCollected({ state, getters, commit, dispatch }, payload) {
      if (!getters.hasAuthentication()) {
        router.push("/login");
        return;
      }

      const params = {
        type: payload.type,
        user: {
          id: state.user.id
        }
      };

      let key = "";

      switch (payload.type) {
        case "EXHIBITOR":
          key = "exhibitor";
          break;
        case "EXHIBIT":
          key = "exhibit";
          break;
        case "LIVESTREAM":
          key = "livestream";
          break;
        case "ARTICLE":
          key = "article";
          break;
        default:
          break;
      }

      params[key] = {
        id: payload.id
      };
      await post("/web/operationAll", {
        userId: state.user.id,
        type: "COLLECTED",
        objectType: payload.type,
        objectId: payload.id
      });
      // await CollectedRecordService.addEntity(params)

      await dispatch("getCollecteds");
    },
    async deleteCollected({ state, getters, dispatch }, payload) {
      // const collected = getters.getCollected(payload.type, payload.id)
      //
      // await CollectedRecordService.deleteEntity({
      //   id: collected.id
      // })
      await post("/web/operationAll", {
        userId: state.user.id,
        type: "COLLECTED",
        objectType: payload.type,
        objectId: payload.id
      });
      await dispatch("getCollecteds");
    },
    async getLikeds({ state, commit }) {
      const result = await get("/my/operationRecordPage", {
        type: "LIKED",
        userId: state.user.id
      });

      commit("SET_LIKED", result.content);
    },
    async addLiked({ state, getters, commit, dispatch }, payload) {
      if (!getters.hasAuthentication()) {
        router.push("/login");
        return;
      }

      const params = {
        type: payload.type,
        user: {
          id: state.user.id
        }
      };

      let key = "";

      switch (payload.type) {
        case "EXHIBITOR":
          key = "exhibitor";
          break;
        case "EXHIBIT":
          key = "exhibit";
          break;
        case "LIVESTREAM":
          key = "livestream";
          break;
        case "ARTICLE":
          key = "article";
          break;
        default:
          break;
      }

      params[key] = {
        id: payload.id
      };

      await post("/web/operationAll", {
        userId: state.user.id,
        type: "LIKED",
        objectType: payload.type,
        objectId: payload.id
      });

      await dispatch("getLikeds");
    },
    async deleteLiked({ state, getters, dispatch }, payload) {
      await post("/web/operationAll", {
        userId: state.user.id,
        type: "LIKED",
        objectType: payload.type,
        objectId: payload.id
      });

      await dispatch("getLikeds");
    },
    async getVenues({ commit }) {
      const venues = await VenueService.getEntities(
        {},
        { sort: "sequence,DESC" }
      );
      commit("setVenues", venues);
    },
    async getExhibitCategories({ commit }) {
      const exhibitCategories = await ExhibtiCategoryService.getEntities(
        { size: 20 },
        { sort: "sequence,DESC" }
      );
      commit("setExhibitCategories", exhibitCategories);
    },
    async getArticleCategories({ commit }) {
      const articleCategories = await get("/web/article-category", {
        language: i18n.locale === "zh" ? "ZH" : "EN"
      });
      commit("setArticleCategories", sortArticleCategories(articleCategories));
    },

    async getAuthenticationUser({ state, commit }) {
      // const user = await UserService.getEntity({
      //   id: state.authentication.user.id
      // })
      const user = await request({
        url: "/user/" + state.authentication.user.id,
        method: "get"
      });
      // 设置account
      commit("SET_USER", user);
    },
    async getUserOrganization({ state, commit }) {
      const organization = await OrganizationService.getEntity({
        id: state.authentication.user.organizationId
      });
      // 设置account
      commit("setOrganization", organization);
    },
    async getOrganizationExhibitor({ state, commit }) {
      const exhibitors = await ExhibitorService.getEntities({
        "organization.id": state.organization.id
      });

      if (exhibitors.length > 0) {
        // 设置account
        commit("setExhibitor", exhibitors[0]);
      }
    }
  },
  modules: {},
  plugins:
    process.env.NODE_ENV !== "production"
      ? [
          createPersistedState({
            storage: window.sessionStorage,
            reducer(value) {
              return {
                authentication: value.authentication,
                account: value.account,
                user: value.user
              };
            }
          })
        ]
      : [
          createLogger(),
          createPersistedState({
            storage: window.sessionStorage,
            reducer(value) {
              return {
                authentication: value.authentication,
                account: value.account,
                user: value.user
              };
            }
          })
        ]
});



// WEBPACK FOOTER //
// ./src/store/index.js